export enum UserRole {
    Staff = 'STAFF',
    Board = 'BOARD',
    Committee = 'COMMITTEE',
    Researcher = 'RESEARCHER',
}

export type ChartItem = {
    key: string
    nameTh: string
    nameEn: string
    value: number
    star?: number
    color?: string
    overdue?: number
}

export type SummaryItem = {
    key: string
    name: string
    color: string
    value?: number
    overdue?: number
    star?: number
    filterKey?: string
}

export type DashboardData = {
    reviewStepList?: ChartItem[]
    submittedTypeList?: ChartItem[]
    projectTypeList?: ChartItem[]
    overviewList?: SummaryItem[]
    pendingList?: SummaryItem[]
    projectStatusList?: ChartItem[]
}
